export default (items = [], capitalize = false, options = {}) => ({
    items,
    errors: [],
    keyCodes: {
        enter: 13,
        comma: 188,
    },

    init(){
        this.$refs.input?.addEventListener('paste', (event) => this.onPaste(event));
        window.addEventListener('set-values', ({detail}) => this.items = detail);
    },

    onKeyup({ target, keyCode }){
        if(! this.validKey(keyCode)){
            return;
        }

        this.addItems(this.parseText(target.value));
    },

    onPaste(event){
        event.preventDefault();

        const paste = (event.clipboardData || window.clipboardData).getData('text');

        this.addItems(this.parseClipboardData(paste));
    },

    onClickOutside(){
        if(! this.$refs.input.value){
            return;
        }

        this.addItems(this.parseText(this.$refs.input.value));
    },

    parseClipboardData(text){
        let data = [];

        text.split(/\r?\n/)
            .forEach(word => data.push(...word.split(',')));

        return data;
    },

    parseText(text){
        return text.replaceAll(',', '').split(/\r?\n/);
    },

    addItems(values){
        let newValues = values.map((value) => String(value).trim().toLowerCase())
            .reduce((map, value, index) => map.get(value) ? map : map.set(value, capitalize ? this.capitalize(values[index]) : values[index]), new Map);

        newValues.forEach((newValue) => {
            const lowerCaseArray = this.items.map((value) => value.toLowerCase());
            const index = lowerCaseArray.findIndex((value) => value === newValue.toLowerCase());

            if (index !== -1) {
                this.items.splice(index, 1);
            }
            });

        this.items.push(...new Set(newValues.values()));
        this.$refs.input.value = '';

        this.dispatchEvent();
    },


    canRemove(index=null){
        const disabled = _.get(options, 'disabled', []) ?? [];

        if(index !== null && disabled.findIndex((itemIndex) => itemIndex == index) > -1) {
            return false;
        }

        const min = _.get(options, 'min', 0);
        return this.items.length > min;
    },

    removeItem(index){
        if(!this.canRemove()) {
            return;
        }

        this.items.splice(index, 1);
        this.dispatchEvent();
    },

    dispatchEvent(){
        const prefix = _.get(options, 'eventPrefix', '') ?? '';

        this.$wire.dispatch(prefix ? `${prefix}::update:items` : 'update:items', [this.items]);
    },

    validKey(keyCode){
        if([this.keyCodes.comma, this.keyCodes.enter].includes(keyCode)){
            return true;
        }

        return false;
    },

    capitalize(value) {
      return String(value).trim()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    getErrors(index) {
        return _.get(this.errors, index)
    },

    setErrors(errors) {
        this.errors = errors;
    },

    getItems(name=null) {
        return this.items.map(
            (item, index) => ({
                item,
                errors: this.getErrors(this.getIndexName(index, name))
            })
        )
    },

    getIndexName(index, name='') {
        return _.filter(
            [name, index],
            (value) => value === 0 || value
        ).join('.')
    }
});
